import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import Advantages from "./components/Adventages.";
import ProductsList from "./components/ProductsList";
import HomePage from "./components/HomePage";
import AboutUs from "./components/AboutUs";
import References from "./components/References";
import Contact from "./components/Contact";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


function App() {
    return (
        <div style={{display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: '#DBD5CE'}}>
            <Header/>
            <main style={{flex: 1}}>
                <HomePage/>
                <AboutUs/>
                <Advantages/>
                <ProductsList />
                <References/>
                <Contact/>
            </main>
            <Footer/>
        </div>
    );
}


export default App;
